import { Tab as TabStyled } from "./styles";

export const Tab = ({ className, ...props }) => {
  return <TabStyled {...props} className={className} />;
};
